import {
  areCidsEqual
} from "./chunk-KPMINROC.js";

// src/ipfs/fetch-snapshot-chain.ts
import * as dagJson from "@ipld/dag-json";
import { Logger } from "besonders-logger";
import { CID } from "multiformats/cid";
var { WARN, LOG, DEBUG, VERBOSE, ERROR } = Logger.setup(Logger.INFO);
async function fetchSnapshotChainUntil(options) {
  const { rootCID, stopAtCID, stopAtCounter, fetchBlock, fetchAll, maxDepth = 100 } = options;
  const blockStore = createMemoryBlockStore();
  const visited = /* @__PURE__ */ new Set();
  let currentCID = rootCID;
  let snapshotCount = 0;
  let minCounter = Infinity;
  let maxCounter = -Infinity;
  while (currentCID && snapshotCount < maxDepth) {
    const cidStr = currentCID.toString();
    if (visited.has(cidStr)) {
      throw ERROR("[fetchSnapshotChain] snapshot chain has a loop", { currentCID: cidStr, visited: [...visited] });
    }
    visited.add(cidStr);
    if (stopAtCID && areCidsEqual(currentCID, stopAtCID)) {
      DEBUG("[fetchSnapshotChain] reached stopAtCID, stopping", stopAtCID.toString());
      break;
    }
    DEBUG("[fetchSnapshotChain] fetching root block", cidStr);
    const rootCar = await fetchBlock(currentCID);
    await addCarBlocksToStore(rootCar, blockStore);
    const rootBytes = await blockStore.get(currentCID);
    if (!rootBytes) {
      throw ERROR("[fetchSnapshotChain] root block not in store after fetch", { currentCID: cidStr });
    }
    const root = dagJson.decode(rootBytes);
    if (typeof root.prevCounter === "number") {
      minCounter = Math.min(minCounter, root.prevCounter);
      maxCounter = Math.max(maxCounter, root.prevCounter);
    }
    if (stopAtCounter !== void 0 && typeof root.prevCounter === "number" && root.prevCounter <= stopAtCounter) {
      DEBUG("[fetchSnapshotChain] reached stopAtCounter", { stopAtCounter, prevCounter: root.prevCounter });
      break;
    }
    DEBUG("[fetchSnapshotChain] fetching applogs", root.applogs.toString());
    const applogsCar = await fetchAll(root.applogs);
    await addCarBlocksToStore(applogsCar, blockStore);
    DEBUG("[fetchSnapshotChain] fetching info", root.info.toString());
    const infoCar = await fetchAll(root.info);
    await addCarBlocksToStore(infoCar, blockStore);
    snapshotCount++;
    currentCID = root.prev;
  }
  DEBUG("[fetchSnapshotChain] done", { snapshotCount, rootCID: rootCID.toString() });
  return {
    rootCID,
    blockStore,
    blocks: blockStore.getBlocksArray(),
    snapshotCount,
    counterRange: minCounter !== Infinity ? { minCounter, maxCounter } : void 0
  };
}
async function addCarBlocksToStore(car, store) {
  for await (const { cid, bytes } of car.blocks()) {
    const validCid = typeof cid.toV1 === "function" ? cid : CID.decode(cid.bytes);
    await store.put(validCid, bytes);
  }
}
function createMemoryBlockStore() {
  const blocks = /* @__PURE__ */ new Map();
  return {
    async get(cid) {
      return blocks.get(cid.toV1().toString());
    },
    async put(cid, bytes) {
      blocks.set(cid.toV1().toString(), bytes);
    },
    getBlocksArray() {
      return Array.from(blocks.entries());
    }
  };
}

export {
  fetchSnapshotChainUntil
};
//# sourceMappingURL=chunk-PSJNDPTB.js.map